// Select all sections
const sections = document.querySelectorAll(".frame-opt-in");

// Loop through sections
sections?.forEach((section) => {
  // Set iframe and consent overlay to constants
  const iframe = section.querySelector(".frame-opt-in__frame__iframe");
  const consent_overlay = section.querySelector(".frame-opt-in__consent");
  // Add eventlistener to consent button
  const consent_btn = section.querySelector(".frame-opt-in__consent__button");
  consent_btn.addEventListener("click", () =>
    loadIframe(iframe, consent_overlay)
  );
});

/**
 * Helper function to set the src for the iFrame and hide the consent overlay.
 * @param {Node} iframe
 * @param {Node} consent_overlay
 * @returns
 */
function loadIframe(iframe, consent_overlay) {
  // Fallback if no iFrame or consent overlay was passed to the function
  if (!iframe || !consent_overlay) return;

  // Set src iFrame
  const iframe_src = iframe.dataset.src;
  if (iframe) {
    iframe.src = iframe_src; // Set value to `src` attribute
    iframe.parentNode?.setAttribute("aria-hidden", "false"); // Set `aria-hidden` attribute an parent to `false`
  }

  // Hide consent overlay
  consent_overlay.setAttribute("aria-hidden", "true"); // Set `aria-hidden` to `true`. This will add the styles to hide the overlay.
}
